// extracted by mini-css-extract-plugin
export default {"wrapper":"BprFsC","title":"d2O9bm","mobile":"_99dsQ","info":"VPrFE1","transaction":"PznDNA"};